<template>
  <v-dialog v-if="dialog" v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <strong> Details </strong>
      </v-card-title>
      <v-card-text>
        <v-layout mb-4>
          {{detailedEvent.title}}
        </v-layout>
        <TreeView :data="{ value: detailedEvent.info }" />
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('Button.Close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      recordEvent: Object,
    },
    data: () => ({
      dialog: false,
      detailedEvent: {},
    }),
    methods: {
      setDetailedEventRecord(recordEvent, processInstanceId) {
        this.dialog = true
        this.detailedEvent['title'] = recordEvent.Message
        this.detailedEvent['info'] = {}
        for (var key in recordEvent) {
          if (key === 'color' || key === 'Message' || key === 'EventLevel') {
            continue
          }
          this.detailedEvent['info'][key] = recordEvent[key]
        }
        this.detailedEvent['info'].ProcessInstanceId = processInstanceId
      },
    },
  }
</script>